import { Button, Card, CardMedia, Column, Typography } from "matsuri-ui"
import { Link, useParams } from "react-router-dom"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import dayjs from "dayjs"
import styled from "@emotion/styled"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { useCleaningInfoDetail } from "@/hooks/useCleaningInfos"
import { useTroublesByListingId } from "@/hooks/useTroubles"
import { useTranslation } from "@/hooks/useTranslation"

const Container = styled.div`
    display: grid;
    gap: 8px;
    margin: 1em;
`

const RightActionArea = styled.div`
    display: flex;
    justify-content: flex-end;
`

export const ListTroublesPage = () => {
    const { t } = useTranslation()
    const { cleaningId } = useParams<"cleaningId">()
    assertIsDefined(cleaningId)

    const { token } = useAuth()
    const { data: cleaningDetail } = useCleaningInfoDetail(token, cleaningId)
    const { data } = useTroublesByListingId(
        token,
        cleaningDetail?.cleaningInfo.listingId
    )

    return (
        <Container>
            <Typography variant="h4">{t("この物件のトラブル一覧")}</Typography>

            <RightActionArea>
                <Button
                    as={Link}
                    to={`../trouble`}
                    variant="filled"
                    color="primary"
                >
                    {t("トラブルを報告")}
                </Button>
            </RightActionArea>

            <Column gap={2}>
                {data?.data.slice(0, 15).map(t => (
                    <a href={t.pictures[0]} key={t.id}>
                        <Card>
                            <CardMedia
                                src={t.pictures[0]}
                                overlay
                                style={{ height: "180px" }}
                            >
                                <Typography variant="h3">
                                    {dayjs
                                        .unix(t.createdAt)
                                        .format("YYYY-MM-DD HH:mm:ss")}
                                </Typography>
                                {t.description}
                            </CardMedia>
                        </Card>
                    </a>
                )) ?? []}
            </Column>
        </Container>
    )
}
